/**
 * Die festen Schlüssel des FinSuites-Webhooks (spec §1.6), so wie sie der Webhook-Bildschirm druckt.
 * FinSuites ist Bastians White-Label von HighLevel; in der Oberfläche heißt es durchgehend FinSuites,
 * im Code und in der Spezifikation bleibt der Hersteller HighLevel.
 * Der Parser im Worker (`src/worker/hooks/parse.ts`) ist die Wahrheit; `test/unit/hlFelder.test.ts` hält
 * diese Liste daran fest, damit der Browser den Parser nicht laden muss.
 */
export interface HlFeld {
  key: string
  pflicht: boolean
  ziel: string
}

export const DEAL_FELDER: readonly HlFeld[] = [
  { key: 'abschluss_id', pflicht: true, ziel: 'Schlüssel des Abschlusses' },
  { key: 'kontakt_id', pflicht: false, ziel: 'FinSuites-Kontakt-ID' },
  { key: 'kunde', pflicht: true, ziel: 'Kundenname' },
  { key: 'produkt', pflicht: false, ziel: 'Produktname oder Dokumentname — daraus wird das Produkt erkannt, wenn kein Kürzel kommt' },
  { key: 'produkt_kuerzel', pflicht: false, ziel: 'Produkt über products.code; schlägt die Erkennung (nur beim ersten Anlegen)' },
  { key: 'unterschrieben_am', pflicht: false, ziel: 'Unterschriftsdatum' },
  { key: 'vertragswert', pflicht: false, ziel: 'Vertragswert' },
  { key: 'vertrag_url', pflicht: false, ziel: 'Link zum Vertrag' },
  { key: 'status', pflicht: false, ziel: 'Status des Abschlusses' },
  { key: 'closer', pflicht: false, ziel: 'Closer — Vor- und Nachname, exakt wie unter Team „Name in FinSuites“ hinterlegt' },
  { key: 'setter', pflicht: false, ziel: 'Setter — Vor- und Nachname, exakt wie unter Team „Name in FinSuites“ hinterlegt' },
  { key: 'host', pflicht: false, ziel: 'Empfehlungsgeber — Vor- und Nachname, exakt wie unter Team „Name in FinSuites“ hinterlegt' },
  { key: 'sonstige', pflicht: false, ziel: 'Sonstige Rolle (z. B. Host) — Vor- und Nachname wie unter Team „Name in FinSuites“' },
  { key: 'host_prozent', pflicht: false, ziel: 'Empfehlungsgeber-Prozent, wenn dieser Abschluss einen eigenen Satz hat (selten)' },
  { key: 'overhead_individuell', pflicht: false, ziel: 'Overhead individuell' },
  { key: 'notizen', pflicht: false, ziel: 'Notizen' },
  { key: 'lead_quelle', pflicht: false, ziel: 'intern (von der Firma gestellt) oder extern (selbst geholt) — leer zählt als intern; ein Tag aus „Tags für externe Leads“ macht extern' },
]

export const PAYMENT_FELDER: readonly HlFeld[] = [
  { key: 'zahlungs_id', pflicht: true, ziel: 'Rechnungsnummer der Kundenrechnung' },
  { key: 'invoice_id', pflicht: false, ziel: 'FinSuites-Rechnungs-ID' },
  { key: 'kontakt_id', pflicht: false, ziel: 'FinSuites-Kontakt-ID' },
  { key: 'kunde', pflicht: false, ziel: 'Kundenname' },
  { key: 'invoice_name', pflicht: false, ziel: 'Rechnungsname — daraus wird das Produkt erkannt' },
  { key: 'bezahlt_am', pflicht: false, ziel: 'Zahlungseingang' },
  { key: 'betrag_bezahlt', pflicht: true, ziel: 'kumulativ bezahlter Betrag' },
  { key: 'rechnung_netto', pflicht: false, ziel: 'Netto der Kundenrechnung' },
  { key: 'rechnung_brutto', pflicht: false, ziel: 'Brutto der Kundenrechnung' },
  { key: 'rechnung_steuer', pflicht: false, ziel: 'Steuer der Kundenrechnung (setzt Netto = Brutto − Steuer)' },
  { key: 'invoice_status', pflicht: false, ziel: 'Status der Kundenrechnung' },
  { key: 'invoice_url', pflicht: false, ziel: 'Link zur Kundenrechnung' },
  { key: 'abschluss_id_manuell', pflicht: false, ziel: 'manuell gesetzter Abschluss' },
]
